/**
 * Initializes data-query attribute decorated elements.
 * data-query attribute flags the element to be used to update querystring parameter.
 * Navigator module is used to change querystring in such way it does not reload entire page,
 * but only push new state to window history and triggers ajax call based on data-query-target attribute,
 * which should point to element with data-ajax attribute.
 * If data-query-target is not specified, $.fn.closest element with data-ajax attribute is used instead.
 */
import $ from 'jquery';
import navigator from '../internal/navigator';
import querystring from '../querystring';
import {ajaxRequest} from '../ajax';
import autoQueryHelper from '../autoQueryHelper';
import oneTimeInitializer from '../internal/oneTimeInitializer';


//TODO: when navigating check data-query-target (must be data-ajax="true") or search for closest [data-ajax="true"]
//TODO: support for data-ajax any element (div, span)

function init() {
// auto query inputs & select key=input name/id, value=$.fn.val()
    $(document).on('change', 'input[data-query], select[data-query]', function () {
        autoQueryHelper(this);
    });

// auto query a[href='?key=value']
    $(document).on('click', '[data-query] a, a[data-query]', function (event) {
        const $a = $(this);
        const href = $a.attr('href');

        if (/^\?/.test(href) // querystring only or href with the same URL as current location with different query parameters
            || querystring.modify(href, () => {
                return {};
            }).toLowerCase() === window.location.pathname.toLowerCase()) {
            event.preventDefault();

            const query = querystring.parse(href);
            navigator.navigate(query, $a);
        }
    });

    $(document).ajaxComplete(function () {
        if (stateToProcess) {
            stateToProcess = false;
            const state = window.history.state.detail;
            if (state && state.uri && state.ajaxElement) {
                processState(state);
            }
        }
    });


    let stateToProcess = false;

    function processState(state) {

        const uri = state.uri;
        const $element = $(state.ajaxElement);

        if ($element.is('[data-ajax="true"]')) {
            if ($element.data('ajaxInProgress')) {
                $element.data('stateToProcess', true);
                return;
            }

            if ($element.is('form')) $element.attr('action', uri).submit();
            else if ($element.is('a')) $element.attr('href', uri).click();
            else {
                ajaxRequest({
                    target: $element.get(0),
                    url: uri,
                    type: "GET",
                    data: []
                });
            }
        }
    }


// watch when window state changes
    navigator.onNavigate((e) => processState(e));
}

export default oneTimeInitializer(init);



// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/autoQuery.js